import { Link } from 'react-router'
import { RestSchemas } from '@/contexts/QueryProvider'
import clsx from 'clsx'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'
import { OrganisationIcon } from '@/const'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export function OrganisationLink({ item }: { item: MessagesSubscriptionsOrganisationSummary }) {
  return (
    <Link className="text-foreground" to={item.id.toString()}>
      <div className="group flex items-start gap-x-4">
        <TooltipButton tooltip={item.active ? 'Active' : 'Inactive'}>
          <div
            className={clsx(
              'flex size-10 shrink-0 items-center justify-center rounded-full',
              item.active ? 'bg-primary/10' : 'bg-offwhite'
            )}
          >
            <OrganisationIcon className={clsx('size-5 text-muted-foreground', item.active && 'text-primary')} />
          </div>
        </TooltipButton>
        <div className="flex flex-col gap-y-1">
          <span className="text-base text-primary group-hover:underline">{item.name}</span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{item.description}</span>
        </div>
        <IconOpenInNewOutline className="ml-auto mr-0 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </div>
    </Link>
  )
}
